// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","976":"c16184b3"}[chunkId] + "-" + {"678":"5171ea5b2bb3a7f5523a","976":"cf2d30ab26c7c934b260"}[chunkId] + ".js";
};